module.exports = __webpack_public_path__ + "static/construction-2bf485f8fc527ddc205d69756f898e9c.png";